

































































import {Vue, Component} from 'vue-property-decorator';
import {SHOPBY_ACCESSTOKEN} from '@/const/words/cookie';
import {getCookie} from '@/utils/cookieUtils';

const accessToken = getCookie(SHOPBY_ACCESSTOKEN);
@Component({})
export default class ProductOptionImageAddForm extends Vue {
  private mainImage: any = null;
  private callback: any = null;
  private index = -1;
  private mallNo = 0;
  private images: any[] = [];
  private addMainImage() {
    const file = Array.from((this.$refs.mainFile as HTMLInputElement).files as FileList)[0];
    this.uploadFile(file, (data: any) => {
      this.mainImage = {
        url: data.url,
        name: file.name
      };
    });
  }
  private addImage(index: number) {
    const ref = `image${index}`;
    const file = Array.from((this.$refs[ref] as HTMLInputElement[])[0].files as FileList)[0];
    this.uploadFile(file, (data: any) => {
      this.images[index] = {
        url: data.url,
        name: file.name
      };
      this.$forceUpdate();
    });
  }
  private uploadFile(file: any, callback: Function): void {
    if (file.size <= 10485760) {
      const data = new FormData();
      data.append('file', file);
      this.$api.postImages({data, params: {mallNo: Number(this.mallNo)}}).then((res) => {
        callback(res.data);
      });
      // axios({
      //   headers: {
      //     Version: '1.0',
      //     'Content-Type': 'multipart/form-data',
      //     accessToken
      //   },
      //   data,
      //   method: 'post',
      //   url: `${process.env.VUE_APP_API_URL}/images?mallNo=${this.mallNo}`
      // }).then((request: any) => {
      //   callback(request.data);
      // });
    } else {
      alert(window.$t('PRODUCT_OPTION_MAX_10'));
      return;
    }
  }
  mounted() {
    this.mallNo = Number(this.$route.query.mallNo);
    this.index = Number(this.$route.query.index);
    this.callback = this.$route.query.dataCallback;
    const queryImages = JSON.parse(this.$route.query.data as string);
    if (queryImages.length) {
      queryImages.forEach((image: any) => {
        if (image.mainYn === 'Y') {
          this.mainImage = {
            url: image.mallOptionImageUrl,
            name: image.mallOptionImageUrl
          };
        } else {
          this.images.push({
            url: image.mallOptionImageUrl,
            name: image.mallOptionImageUrl
          });
        }
      });
    }else{
      this.images.push({name: '', url: ''});
    }
    if (this.images.length === 0) {
      this.images.push({name: '', url: ''});
    }
  }
  addImages() {
    if (this.images.length < 5) {
      this.images.push({name: '', url: ''});
    } else {
      alert(window.$t('PRODUCT_OPTION_TIP_MAX_5CASE'));
    }
  }
  save() {
    if (!this.mainImage && this.images[0].url) {
      alert(window.$t('PRODUCT_OPTION_PLEASE_OPTION_REPRESENT'));
      return;
    }
    if (!this.images[0].url && this.mainImage) {
      alert(window.$t('PRODUCT_OPTION_PLEASE_OPTION_DETAIL_IMG'));
      return;
    }

    const imageInfo = {
      index: this.index,
      mainImage: this.mainImage,
      images: this.images
    };

    $(window.opener.location).attr('href', `javascript:window.${this.callback}(${JSON.stringify(imageInfo)});`);

    window.close();
  }
  removeImage(index:number){
    this.images[index] = {name: '', url: ''};
    this.$forceUpdate();
  }
}
